import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import Seo from "@/components/Seo";

export default function NotFoundPage() {
  return (
    <>
      <Seo title="Page not found — SAIVU" description="The page you're looking for doesn't exist." path="/404" />
      <section className="flex min-h-[80vh] flex-col items-center justify-center bg-white px-6 pt-28 text-center" data-testid="not-found-page">
        <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-gold-deep">404</p>
        <h1 className="mt-4 text-4xl font-bold tracking-tight text-navy-900 sm:text-5xl">Wrong turn. Happens.</h1>
        <p className="mt-4 max-w-md text-sm leading-relaxed text-ink sm:text-base">
          The page you're after doesn't exist — but everything your business needs to file,
          pay or prove is two clicks away.
        </p>
        <div className="mt-9 flex flex-wrap justify-center gap-4">
          <Link to="/" className="rounded-md bg-navy-900 px-6 py-3 text-sm font-semibold text-white transition-colors hover:bg-navy-800" data-testid="notfound-home-link">
            Back home
          </Link>
          <Link to="/services" className="inline-flex items-center gap-2 rounded-md border border-line bg-white px-6 py-3 text-sm font-medium text-navy-900 transition-colors hover:border-navy-900" data-testid="notfound-services-link">
            All services <ArrowUpRight className="h-4 w-4" />
          </Link>
        </div>
      </section>
    </>
  );
}
